export default {
  props: {
    name: String,
  },
};
